import {Component, OnInit, OnDestroy, ViewChild, HostListener} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {MenuItems} from '../../shared/menu-items/menu-items';
import {Subscription} from 'rxjs/Subscription';
import {DatePipe} from '@angular/common';
import 'rxjs/add/operator/filter';

import {TranslateService} from 'ng2-translate/ng2-translate';
import PerfectScrollbar from 'perfect-scrollbar';
import {
    PerfectScrollbarConfigInterface,
    PerfectScrollbarComponent, PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';

import {AuthenticationService} from '../../service/authentication.service';
import {EspaceService} from '../../service/espace.service';
import {ReservationService} from '../../service/reservation.service';
import {PlanningService} from '../../service/planning.service';

import {Utilisateur} from '../../model/utilisateur.model';
import {Espace} from '../../model/espace.model';
import {Reservation} from '../../model/reservation.model';
import {Planning} from '../../model/planning.model';
import {ConfigService} from '../../shared/config.service';
import { from } from 'rxjs/observable/from';
import {MatSnackBar} from '@angular/material';


@Component({
    selector: 'app-layout',
    templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
    _baseUrl: string = '';
    private _router: Subscription;
    currentUser: Utilisateur;
    isAdmin: boolean;
    espaces: Espace[];
    resaClient: Reservation[];
    mesPlanning: Planning[];
    nombreReservation: number;
    nombrePlanning: number;
    listResa = [];

    today: number = Date.now();
    url: string;
    showSettings = false;
    dark: boolean;
    boxed: boolean;
    collapseSidebar: boolean;
    compactSidebar: boolean;
    sidebarBg: boolean = true;
    currentLang = 'en';
    layoutDir = 'ltr';
    datePipe: DatePipe;

    selectedSidebarImage: any = 'bg-1';
    selectedSidebarColor: any = 'sidebar-purple';
    selectedHeaderColor: any = 'header-default';
    collapsedClass: any = 'side-panel-opened';
    nbReservation: number;
    @ViewChild('sidemenu') sidemenu;
    public config: PerfectScrollbarConfigInterface = {};

    constructor(private router: Router,
                public menuItems: MenuItems,
                public translate: TranslateService,
                private authenticationService: AuthenticationService,
                private espaceService: EspaceService,
                private reservationService: ReservationService,
                private configService: ConfigService,
                private planningService: PlanningService,
                public snackBar: MatSnackBar
                ) {
        const browserLang: string = translate.getBrowserLang();
        translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

        this._baseUrl = configService.getApiURI();
        this.configService.nbReservationCours.asObservable().subscribe(data => {
          this.nombreReservation = data;
        });
      this.configService.nbReservationEspace.asObservable().subscribe(data => {
        this.nombrePlanning = data;
      });
        this.currentUser = JSON.parse(sessionStorage.getItem('parklife'));
        if (this.currentUser.idclient == '0') {
            this.isAdmin = true;

        } else {
            this.isAdmin = false;
            this.datePipe = new DatePipe('en-US');
            this.refreshReservationState();

        }

        this.datePipe = new DatePipe('en-US');

    }

    ngOnInit(): void {
        // console.log (this.currentUser);
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container ');
        // const elemSidebar = <HTMLElement>document.querySelector('.app-inner > .sidebar-panel');
        // const elemContent = <HTMLElement>document.querySelector('.app-inner > .mat-sidenav-content');

        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !this.compactSidebar) {
            // Ps.initialize(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
            // Ps.initialize(elemContent, { wheelSpeed: 2, suppressScrollX: true });
            const ps = new PerfectScrollbar(elemSidebar, {
                wheelSpeed: 2,
                suppressScrollX: true
            });

            this.espaceService.getAll().subscribe(res => {
                this.espaces = res;
            });


        }

        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            this.url = event.url;
            /*if (this.isOver()) {
                this.sidemenu.close();
            }

            if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !this.compactSidebar) {
                // Ps.update(elemContent);
            }*/
            this.sidemenu.close();
        });
    }

    @HostListener('click', ['$event'])
    onClick(e: any) {
        // const elemSidebar = <HTMLElement>document.querySelector('.app-inner > .sidebar-panel');
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container ');
        setTimeout(() => {
            if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !this.compactSidebar) {
                // Ps.update(elemSidebar);
                const ps = new PerfectScrollbar(elemSidebar, {
                    wheelSpeed: 2,
                    suppressScrollX: true
                });
            }
        }, 350);
    }

    ngOnDestroy() {
        this._router.unsubscribe();
    }

    isOver(): boolean {
        if (this.url === '/apps/messages' || this.url === '/apps/calendar' || this.url === '/apps/media' || this.url === '/maps/leaflet') {
            return true;
        } else {
            return window.matchMedia(`(max-width: 960px)`).matches;
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    menuMouseOver(): void {

        // console.log ('menu over');

        if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
            this.sidemenu.mode = 'over';
        }
    }

    menuMouseOut(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
            this.sidemenu.mode = 'side';
        }
    }

    menuToggleFunc() {
        this.sidemenu.toggle();

        if (this.collapsedClass == 'side-panel-opened') {
            this.collapsedClass = 'side-panel-closed';
        }
        else {
            this.collapsedClass = 'side-panel-opened';
        }
    }

    onSelectSidebarImage(selectedClass, event) {
        this.selectedSidebarImage = selectedClass;
    }

    onSelectedSidebarColor(selectedClass) {
        this.selectedSidebarColor = selectedClass;
    }

    onSelectedHeaderColor(selectedClass) {
        this.selectedHeaderColor = selectedClass;
    }

    isBgActive(value) {
        if (value == this.selectedSidebarImage) {
            return true;
        }
        else {
            return false;
        }
    }

    isSidebarActive(value) {
        if (value == this.selectedSidebarColor) {
            return true;
        }
        else {
            return false;
        }
    }

    isHeaderActive(value) {
        if (value == this.selectedHeaderColor) {
            return true;
        }
        else {
            return false;
        }
    }

    addMenuItem(): void {
        this.menuItems.add({
            state: 'menu',
            name: 'MENU',
            type: 'sub',
            icon: 'trending_flat',
            children: [
                {state: 'menu', name: 'MENU'},
                {state: 'timelmenuine', name: 'MENU'}
            ]
        });
    }

    logout() {
        this.authenticationService.logout();

        this.router.navigate(['/authentication/login'])
    }

    changepassword() {
        this.router.navigate(['/administration/changepassword'])
    }

    cancelCours(index: number) {


        //console.log(this.resaClient[index]);

        this.resaClient = JSON.parse(sessionStorage.getItem('resa'));
        this.reservationService.delete(this.resaClient[index].idreservation).subscribe(res => {
            this.resaClient.splice(index, 1);

            sessionStorage.setItem('resa', JSON.stringify(this.resaClient));

            this.nombreReservation = this.resaClient.length;

            // this.coursResa.afficherCours(this.datePipe.transform(this.today, 'yyyy-MM-dd'), this.currentUser.idclient);
            this.reservationService._actionDelete.next(true);
            // console.log ('delete cours');
        });
        //

    }


    getResa() {

        if (this.currentUser.idclient != '0') {
          this.listResa = [];

            this.listResa = JSON.parse(sessionStorage.getItem('resa'));
            if (this.listResa) {
                this.nombreReservation = this.listResa.length;
            } else {
                this.nombreReservation = 0;
            }


        }

        return null;


    }
    refreshReservationState() {
      const date = new Date();

      this.reservationService.getByClient(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient).subscribe(res => {
        sessionStorage.setItem('resa', JSON.stringify(res));

        this.resaClient = JSON.parse(sessionStorage.getItem('resa'));

        this.configService.nbReservationCours.next(this.resaClient.length);
      });
      this.planningService.getAllUser(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idutilisateur).subscribe(plans => {
        sessionStorage.setItem('plan', JSON.stringify(plans));
        this.mesPlanning = JSON.parse(sessionStorage.getItem('plan'));

        this.configService.nbReservationEspace.next(this.mesPlanning.length);
        // console.log(this.mesPlanning);
      });
    }

    cancelPlanning(index: number) {

        this.mesPlanning = JSON.parse(sessionStorage.getItem('plan'));
        //this.mesPlanning.splice(index, 1);
        //sessionStorage.setItem('plan', JSON.stringify(this.mesPlanning));

        this.planningService.delete(this.mesPlanning[index].idplanning).subscribe(res => {
            //  this.mesPlanning =  JSON.parse(sessionStorage.getItem('plan'));
            this.mesPlanning.splice(index, 1);

            sessionStorage.setItem('plan', JSON.stringify(this.mesPlanning));

            this.nombrePlanning = this.mesPlanning.length;

            this.planningService._planningDelete.next(true);
        });

    }

    getPlan() {
        if (this.currentUser.idclient != '0') {
            let listPlan = [];
            listPlan = JSON.parse(sessionStorage.getItem('plan'));

            if (listPlan) {
                this.nombrePlanning = listPlan.length;
            } else {
                this.nombrePlanning = 0;
            }

            return JSON.parse(sessionStorage.getItem('plan'));
        }
        return null;

    }
  // handle get planning
  getPDF() {
      this.planningService.getPdfPlanning().subscribe( result => {
        // console.log('success');
        window.open(this._baseUrl + 'docplanning/download', '_blank');
      }, error => {
        this.snackBar.open('Pas de planning à télécharger pour le moment', null, {
          duration: 2000,
        });
        // console.log('here');
      });
  }

}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/layouts/admin/admin-layout.component.ts